export const environment = {
  production: true,
  buildId: '3999047674024321',
  configFile: 'config.json',
};
